<template>
    <div class="relative h-16">
        <input
            autofocus
            type="search"
            class="input-search rounded-none"
            :placeholder="$t('search.placeholder')"
            v-model="inputValue"
        >
        <AtomIcSearch :width="35" class="absolute opacity-20 left-2 top-1/2 transform -translate-y-1/2" />
        <AtomIcClose
            :width="15" @click.native="clearSearch"
            class="absolute cursor-pointer right-4 top-1/2 transform -translate-y-1/2"
        />
    </div>
</template>

<script>
import AtomIcSearch from "../atoms/AtomIcSearch.vue";
import AtomIcClose from "../atoms/AtomIcClose.vue";

export default {
    name: "MoleculePreviewInput",
    components: {AtomIcClose, AtomIcSearch},
    props: {
        value: String
    },
    data() {
        return {
            inputValue: this.value
        };
    },
    watch: {
        inputValue(newValue) {
            this.$emit("input", newValue);
        }
    },
    methods: {
        clearSearch(){
            console.log('clean')
            this.inputValue = ""
        }
    }
}
</script>

<style scoped>
.input-search{
    @apply h-full w-full pl-12 text-white focus:outline-none;
    background: rgba(0, 0, 0, 0.70);
    background-blend-mode: darken;
    backdrop-filter: blur(82px);
}
</style>
